import React, { useState, useEffect, useRef } from "react";
import {
  Section,
  Container,
  Left,
  Right,
  Title,
  Description,
  Button,
  ImageSlider,
  Track,
  Slide,
  NavButton,
  Dots,
  Dot,
  ThumbStrip,
  Thumb,
} from "./WellbeingStyles";

import logo from "assets/wellbeingday.png";

const images = [
  "/assets/wellbeing/well1.jpg",
  "/assets/wellbeing/well2.jpg",
  "/assets/wellbeing/well3.jpeg",
  "/assets/wellbeing/well04.jpg",
  "/assets/wellbeing/well4.jpg",
  "/assets/wellbeing/well5.jpg",
  "/assets/wellbeing/well06.jpg",
  "/assets/wellbeing/well6.jpeg",
  "/assets/wellbeing/well7.jpeg",
  "/assets/wellbeing/well8.jpeg",
  "/assets/wellbeing/well9.jpeg",
  "/assets/wellbeing/well10.jpg",
];

const Wellbeing = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const autoRef = useRef();

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  // autoplay
  useEffect(() => {
    autoRef.current = nextSlide;
  });

  useEffect(() => {
    if (paused) return;
    const id = setInterval(() => autoRef.current(), 4000);
    return () => clearInterval(id);
  }, [paused]);

  return (
    <Section>
      <Container>
        <Left>
          <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1.5rem" }}>
            <img src={logo} alt='Well-being Day' className='wb-logo' />
          </div>

          <div style={{ textAlign: "justify" }}>
            Wellbeing Day at Indian Institute of Technology Kharagpur is a student-focused initiative organized by the
            Students’ Welfare Committee to promote mental, emotional, and physical wellness across the campus community.
            The event features interactive workshops, counselling sessions, cultural activities, fitness programs,
            discussions on mental health awareness, and community-building activities aimed at creating a more
            supportive and compassionate campus environment. It reflects IIT Kharagpur’s growing emphasis on holistic
            student wellbeing under initiatives like Student Mentorship Programme, Career Mentorship Programme, Peer
            Assisted Learning, and SETU (Support, Empathy, Transformation, and Upliftment).
          </div>

          {/* <Button href="/events">
            Explore Other Events
          </Button> */}
        </Left>

        <Right>
          <ImageSlider onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
            <Track style={{ transform: `translateX(-${index * 100}%)` }}>
              {images.map((img, i) => (
                <Slide key={i} className={i === index ? "active" : ""}>
                  <img src={img} alt={`wellbeing-${i}`} />
                </Slide>
              ))}
            </Track>

            <NavButton left onClick={prevSlide} aria-label='previous slide'>
              ‹
            </NavButton>

            <NavButton onClick={nextSlide} aria-label='next slide'>
              ›
            </NavButton>

            <Dots>
              {images.map((_, i) => (
                <Dot key={i} active={i === index} onClick={() => setIndex(i)} />
              ))}
            </Dots>

            <ThumbStrip>
              {images.map((img, i) => (
                <Thumb
                  key={i}
                  src={img}
                  className={i === index ? "active" : ""}
                  onClick={() => setIndex(i)}
                  alt={`thumb-${i}`}
                />
              ))}
            </ThumbStrip>
          </ImageSlider>
        </Right>
      </Container>
    </Section>
  );
};

export default Wellbeing;
